import { render, staticRenderFns } from "./RichMenuSelectTemplate.vue?vue&type=template&id=399d6aeb&"
import script from "./RichMenuSelectTemplate.vue?vue&type=script&lang=js&"
export * from "./RichMenuSelectTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuSelectTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports